import { render } from "./DriversLicense.vue?vue&type=template&id=5f697e64&scoped=true"
import script from "./DriversLicense.vue?vue&type=script&lang=js"
export * from "./DriversLicense.vue?vue&type=script&lang=js"

import "./DriversLicense.vue?vue&type=style&index=0&id=5f697e64&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f697e64"]])

export default __exports__